import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/events", label: "事件库" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

const hotTopics = [
  { to: "/event/1001", label: "顶流机场生图" },
  { to: "/event/1005", label: "音乐节万人合唱" },
  { to: "/event/1009", label: "公益直播破纪录" },
  { to: "/event/1003", label: "红人带货翻车" },
  { to: "/event/1002", label: "恋综名场面" },
];

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-background-100">
      <div className="container-x grid grid-cols-1 gap-10 py-12 sm:grid-cols-2 lg:grid-cols-4">
        <div className="sm:col-span-2 lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-900">吃瓜速递</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
            国产吃瓜视频最新热点实时速递，聚焦近期热门吃瓜事件与八卦汇总，持续更新视频内容。想看最新、热点事件或完整汇总，收藏本站每日刷新即可。
          </p>
          <div className="mt-5 flex items-center gap-3 text-foreground-600">
            <a
              href="#"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-sm transition-colors hover:border-primary-300 hover:text-primary-600"
              aria-label="微博"
            >
              <i className="ri-weibo-line"></i>
            </a>
            <a
              href="#"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-sm transition-colors hover:border-primary-300 hover:text-primary-600"
              aria-label="微信"
            >
              <i className="ri-wechat-line"></i>
            </a>
            <a
              href="#"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-sm transition-colors hover:border-primary-300 hover:text-primary-600"
              aria-label="抖音"
            >
              <i className="ri-music-2-line"></i>
            </a>
          </div>
        </div>

        <nav aria-label="快速导航">
          <h4 className="mb-4 text-sm font-semibold text-foreground-800">快速导航</h4>
          <ul className="space-y-2.5">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="热点事件">
          <h4 className="mb-4 text-sm font-semibold text-foreground-800">热点事件</h4>
          <ul className="space-y-2.5">
            {hotTopics.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-background-200">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-5 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜速递 · 国产吃瓜视频热点资讯聚合站
          </p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-flashlight-line"></i>
            每日更新 · 热门吃瓜事件 · 八卦汇总速递
          </p>
        </div>
      </div>
    </footer>
  );
}